module.exports = __webpack_public_path__ + "static/media/G-slogan@2x.cb2c8e45.png";